import styled, { from } from 'theme';

import searchIcon from '../../assets/icons/search.svg';

export const PageWrapper = styled.div`
  padding: 1rem;

  ${from('md')} {
    padding: 2rem;
  }

  ${from('xlg')} {
    padding: 4rem 5rem 4rem 4rem;
  }

  .header__row {
    font-weight: ${props => props.theme.variables.fonts.weight.bold};
    background-color: ${p => p.theme.variables.colors.lightGrey};
    .header__cell {
      cursor: default;
      padding: 1rem;
    }
  }

  .table-body__row {
    cursor: default;
    background-color: ${props => props.theme.variables.colors.white};
    .table__body-cell {
      padding: 0.5rem 1rem;
    }
  }
`;

export const ActionButtonWrapper = styled.div`
  .button--action {
    background-color: ${props => props.theme.variables.colors.red};

    &:hover {
      background-color: ${props => props.theme.variables.colors.darkRed};
    }
    padding: 0 2rem;
  }
`;

export const SearchInput = styled.input`
  width: 15rem;
  z-index: 1;
  height: 2rem;
  border: none;
  background-color: #95959566;
  background-image: url(${searchIcon});
  background-repeat: no-repeat;
  background-position: 0.4rem 0.4rem;
  border-radius: 15px;
  color: ${props => props.theme.variables.colors.white};
  font-size: 1rem;
  line-height: 1.5;
  text-indent: 2.5rem;
  outline: none;

  ::placeholder {
    color: ${props => props.theme.variables.colors.white};
  }
`;

export const SearchInputWrapper = styled.div``;
